import { React, useState,useEffect } from "react";
import "./landing.css";
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import image from  "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from  "./img/back.png";
import {CREATE_VPN_ACCESS} from '../AppConstant'
function Landing() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [contact, setContact] = useState("");
    const [pan, setPan] = useState("");
    const [bod, setBod] = useState("");
    const [doj, setDoj] = useState("");
    const [requestorname,setRequestorname]= useState("");
    const [requestdept,setRequestdept]= useState("");
    const [purpose,setPurpose]= useState("");
    const [asset_id,setAsset_id]= useState("");
    const [selectedrpmanager,setSelectedrpmanager] = useState("");
    const [ifchecked,setIfchecked] = useState(false);
    const [selectedtext,setSelectedtext] = useState("");
    const [start,setStart] = useState(""); 
    const [end,setEnd] = useState(""); 
    const [mindateset,setMindateset] = useState("")
    
   
    const calltosetmindate=()=>{
        setSelectedrpmanager(localStorage.getItem('functionheademail'))
        let month;
        let day;
        if((new Date().getMonth()+1)<10){
            month="0"+(new Date().getMonth()+1)
        }else{
            month= (new Date().getMonth()+1)
        }
        if( new Date().getDate()<10){
            day= "0"+new Date().getDate()
        }else{
            day= new Date().getDate()
        }
        let date = new Date().getFullYear()+'-'+month+'-'+day
       setMindateset(date)
    }
    useEffect(()=>{calltosetmindate()},[])
    const handleSubmit = (e) => {
        e.preventDefault();
        if(!purpose||!asset_id||!selectedrpmanager){
            alert("Please fill all the fields")
        }else{
            getUserData();
            
        }
        
        // Add your form submission logic here
        
    };

    const redirectToLogin = ()=>{
        window.location.href = "/login"
    }
    
     const handleReset = () => {
        // Reset all state variables here
        setRequestdept("");
        setRequestorname("");
        setPurpose("");
        setAsset_id("");
        setSelectedrpmanager("")
        setIfchecked(false)
        const Checkboxes = document.getElementById('checkboxs');
        if(Checkboxes.checked===true){
            Checkboxes.checked=false
        }
        
    };
    const getUserData = ()=>{
       
        let empid=  localStorage.getItem('empid');
        let rqdept= localStorage.getItem('dept');
        let reason= purpose
        let assetid= asset_id
        let fhemailid= localStorage.getItem('reporting_manageremail')
        let empemailid = localStorage.getItem('emailid');
        let empname = localStorage.getItem('empname');
        let fhname =localStorage.getItem('reporting_managername');
        let startdate = start;
        let enddate = end;
       
       
                
        axios.post(CREATE_VPN_ACCESS, {empid,rqdept,reason,assetid,fhemailid,empemailid,fhname,empname,startdate,enddate})
        .then(function (response) {
          //console.log("SuccessFully updated");
          alert(response.data);
          handleReset();
          

        })
          .catch(function (error) {
            console.log(error);
          });
       
    }
    const redirectTodashboard = ()=>{
        window.location.href = "/landingPage"
    }

    const checkedval=(e)=>{
        if(e.currentTarget.checked===true){
            setIfchecked(true)
        }else{
            setIfchecked(false)
        }
       
    }
    const callselectedfn=(e)=>{
        setSelectedrpmanager(e.target.value)
        setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
    }
    const callinputsetfn=(e)=>{
        if(e.target.value.length>6){
            alert("Employee ID cannot exceed 6 digit")           
        }else{
            setRequestorname(e.target.value)
        }   
        
    }
    const isAlpha = checkvalue => /^[a-zA-Z]*$/.test(checkvalue)
    const assetentryfn=(e)=>{
        let checkvalue =e.target.value
        if(e.target.value.length===12){
            let strRegex = new RegExp(/^[A-Za-z]+$/i);
            let result1 = strRegex.test(checkvalue);
            let strRegex2 = new RegExp(/^[0-9]+$/i);
            let result2 = strRegex2.test(checkvalue);
            if(result1 || result2===true){
                alert("Should contain alphanumeric")
            }
           
        }
        setAsset_id(e.target.value)
    }
    
    return (
       <form action="#" method="get">
                <div className="row">
                    {/* <div className="col-md-6">
                    <label for="firstname">
                    Emp ID
                    </label>
                    <input
                        type="number"
                        name="firstname"
                        id="firstname"
                        value={requestorname}
                        onChange={(e) =>
                            callinputsetfn(e)
                        }
                        maxlength="6"
                        placeholder="Emp ID"
                        required
                    />
                    </div> */}
                    {/* <div className="col-md-6">
                    <label for="lastname">Requestor department</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={requestdept}
                        onChange={(e) =>
                            setRequestdept(e.target.value)
                        }
                        placeholder="Department"
                        required
                        maxlength="30"
                    />
                    </div> */}
                    </div>
                    <div className="row">
                    <div className="col-md-12">
                    <label for="firstname">
                    Purpose to provide VPN access
                    </label>
                    <input
                        type="text"
                        name="firstname"
                        id="firstname"
                        value={purpose}
                        onChange={(e) =>
                            setPurpose(e.target.value)
                        }
                        placeholder="Purpose to provide VPN access"
                        required
                    />
                    </div>
                    <div className="col-md-6"> <label for="lastname">Start Date</label>
                    <input type="date"  min={mindateset} onChange={(e) =>setStart(e.target.value)} id="birthday" name="birthday"/>
                    </div>
                    <div className="col-md-6">
                    <label for="lastname">End Date</label>
                    <input type="date"   min={mindateset} onChange={(e) =>setEnd(e.target.value)} id="birthday" name="birthday"/>
                    </div>
                    <div className="col-md-6">
                    <label for="lastname">Asset ID</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={asset_id}
                        onChange={(e) =>
                            assetentryfn(e)                          
                        }
                        
                        placeholder="Asset ID"
                        required
                         maxlength="12"
                    />
                    </div>
                    <div className="col-md-6">
                    <label>  Reporting Manager</label>
                    <select
                        name="select"
                        id="select"
                        value={selectedrpmanager}
                        onChange={(e) =>callselectedfn(e)}
                    >
                       <option
                                            value=""
                                            disabled
                                            selected={selectedrpmanager === ""}
                                        >
                                            Reporting Manager
                                        </option>
                                         <option  value={localStorage.getItem('reporting_manageremail')}>{localStorage.getItem('reporting_managername')}</option>


																																																		  
																																																																							
																																																																																						   
																																																																			  
																																																																																											  
																																																																   
																																																																									   
																																																																													 
																																																													  
                            
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
                    </div>
					<div className="text-design-note">Note: Please provide a detailed justification for the access request.</div>
                    <div className="row">
                    <div className="col-md-6">
                    <Button
                        variant="primary"
                        className="btns"
                        type="reset"
                        value="reset"
                        onClick={() => handleReset()}
                    >
                        Clear
                    </Button>
                    </div>
                    <div className="col-md-6">
                    <Button
                    variant="primary"
                      className="btns"
                        type="submit"
                        value="Submit"
                        onClick={(e) => handleSubmit(e)}
                    >
                        Submit
                    </Button>
                    </div>
                    </div>
                </form>
        // <div className="bg_set_usb">   
        //  <div className="switch" >
        //             <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/>
        //             <img className="switch-img" src={image}/>
        //             <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
        //         </div><br/><br/>         
        //      <div>
        //     </div>
        //     <div>
        // <div className="Apps ">
        //     <p className="Headings">VPN Requisition</p>
        //     <fieldset>
                
        //     </fieldset>
        // </div> 
        //     </div>
        
        // </div>
    );
}


export default Landing;
